export default {"src":"/_next/static/media/closeEye.f2558238.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};